
class secondaryWindow {

	constructor()
		{
			
		}
	
	openNewWindows() 
		{
			var $ = window.$ || {};
			var ww = window.open("","window1","left=-1550,top=0,width=5000,height=5000,scrollbars=1,menubar=no,resizable=1")

			ww.document.open();
			ww.document.write(this.getFullHtml());
			
			var ww1 = window.open("","window2","left=1550,top=0,width=5000,height=5000,scrollbars=1,menubar=no,resizable=1")

			ww1.document.open();
			ww1.document.write(this.getFullHtml());
			
			window['multiWindow1'] = ww;
			window['multiWindow2'] = ww1;
			
			if ( window['pendingFunctionsOff'] )
				{
					window['pendingFunctionsOff'].forEach((item) => {
						$(ww.document).off(item[0], item[1], item[2], item[3]);
						$(ww1.document).off(item[0], item[1], item[2], item[3]);
					});
				}
			
			if ( window['pendingFunctionsOn'] )
				{
					window['pendingFunctionsOn'].forEach((item) => {
						$(ww.document).on(item[0], item[1], item[2], item[3]);
						$(ww1.document).on(item[0], item[1], item[2], item[3]);
					});
				}
			
			//window.mrequire = require;
		}
		
	getFullHtml()
		{
			var htmlText = '';
			if ( window['hasConeScript'] )
				{
					htmlText = '<html style="background-color: #000" >'+
					'<head>'+
						'<link rel="stylesheet" href="'+this.getFilePath('styleD2C.css')+'?version=4.1.1">'+
						'<link rel="preconnect" href="https://fonts.googleapis.com">'+
						'<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>'+
						'<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap" rel="stylesheet">'+
					'</head>'+
					'<body style="background-color: #000" >'+
						'<div id="participantListView">'+
							'<div style="padding-top: 15px; text-align: center;  cursor: pointer" id="statistic_participants">'+ 
								'<div style="display: inline-block; width: fit-content; padding: 15px; border-radius: 15px; background-color: #bbb; font-weight: 600; font-size: 20px; position: absolute; left: 50%; transform: translate(-50%); z-index: 2;" > Signed Up: <span id="singedUpD2C">0</span> | Online: <span id="onlineD2C">0</span> | Waiting Lounge: <span id="waitingD2C">0</span> | Room Setup: <span id="roomSetupD2C">0</span> </div>' +
							'</div>'+
						'</div>'+
					'</body></html>';
				}
			else
				{
					htmlText = '<html style="background-color: #000" >'+
					'<head>'+
						'<link rel="stylesheet" href="'+this.getFilePath('styleD2C.css')+'?version=4.1.1">'+
						'<link rel="preconnect" href="https://fonts.googleapis.com">'+
						'<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>'+
						'<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap" rel="stylesheet">'+
					'</head>'+
					'<body style="background-color: #000" >'+
						'<div id="participantListView">'+
							'<div style="padding-top: 15px; text-align: center;  cursor: pointer" id="statistic_participants">'+ 
								'<div style="display: inline-block; padding: 15px; border-radius: 15px; background-color: #bbb; font-weight: 600; font-size: 20px; position: absolute; left: 50%; transform: translate(-50%); z-index: 2;" > Signed Up: <span id="singedUpD2C">0</span> | Online: <span id="onlineD2C">0</span> | Waiting Lounge: <span id="waitingD2C">0</span> </div>' +
							'</div>'+
						'</div>'+
					'</body></html>';
				}
			
			//var css = require('../../public/css/style.css').toString();
			
			return htmlText;
		}
		
	getFilePath(fileName)
		{
			if ( window['applicationPath'] )
				{
					if ( window['applicationPath'].indexOf('asar') > 0 && window.navigator.appVersion.indexOf('Windows') > -1 )
						{
							return 'file:///'+(window['applicationPath'].replace(/\\/g, '/').replace('resources/app.asar', ''))+fileName;
						}
					else
						{
							return 'file:///'+(window['applicationPath'].replace(/\\/g, '/'))+'/build/css/'+fileName;
						}
				}
		}
}

export default secondaryWindow;